import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";

export class NotificationVet {
  userNotificationContactId: number;
  email: string | null;
  mobile: string | null;
  countryCode: string | null;
  mobileNumberControl: {} | null;
  selectedCountryISO: string | null;
  isPrimary: boolean;
  userNotificationType: NotificationVetNotificationType[] = [];

  static asFormGroup(model: NotificationVet | null): FormGroup {
    const userNotificationTypes = model?.userNotificationType.map(NotificationVetNotificationType.asFormGroup) || [];
    return new FormGroup({
      userNotificationContactId: new FormControl(model?.userNotificationContactId),
      email: model?.email ? new FormControl(model?.email, [Validators.required, Validators.email]) : new FormControl(model?.email),
      mobile: model?.mobile ? new FormControl(model?.mobile, []) : new FormControl(model?.mobile),
      countryCode: model?.mobile ? new FormControl(model?.countryCode, [Validators.required]) : new FormControl(model?.countryCode),
      isPrimaryEmail: new FormControl(model?.isPrimary),
      isPrimaryMobile: new FormControl(model?.isPrimary),
      userNotificationType: new FormArray(userNotificationTypes),
      mobileNumberControl : model?.mobileNumberControl ? new FormControl(model?.mobileNumberControl, [Validators.required]): new FormControl(model?.mobileNumberControl),
      selectedCountryISO : new FormControl(model?.selectedCountryISO),
    });
  }
}

export class NotificationVetNotificationType {
  notificationTypeId: number;
  static asFormGroup(model: NotificationVetNotificationType | null): FormGroup {
    return new FormGroup({
      notificationTypeId: new FormControl(model?.notificationTypeId)
    });
  }
}
